import { ExternalLink } from 'lucide-react';
import { targetPostUrl, type TargetPost } from './bounty-shared';

/**
 * Which listed posts mattered (Nick, 2026-11-03): per post, who commented since it went
 * live and the payouts it completed. Each payout is credited to the member's last listed
 * comment before it paid, so no payout counts twice. Most points first.
 */
export function BountyTargetPosts({ posts }: { posts: TargetPost[] }) {
  const ranked = [...posts].sort((a, b) => b.points - a.points || b.paid - a.paid || b.commenters - a.commenters);
  return (
    <div className="space-y-2 rounded-lg border border-gray-200 bg-white p-4" data-testid="bounty-target-posts">
      <p className="text-sm font-semibold text-gray-900">Which posts earned it</p>
      <ul className="divide-y">
        {ranked.map((post) => (
          <li key={post.postId} className="py-2 text-sm">
            <a
              href={targetPostUrl(post.path)}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 break-words font-medium text-gray-900 hover:underline"
            >
              {post.title || post.path}
              <ExternalLink className="h-3 w-3 shrink-0" />
            </a>
            <p className="text-xs text-gray-500">
              {post.commenters.toLocaleString()} commented · {post.paid.toLocaleString()} paid ·{' '}
              {post.points.toLocaleString()} points
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
}
